import React, { useState } from "react";
import Alert from "ui/build/components/Alert/Alert";
import Loader from "ui/build/components/Loader/Loader";

import { t } from "../../../utils/ResourceUtils";
import SubTenantChange from "../../../utils/SubTenantChange";
import ChangeSub from "./ChangeSub";

export default function SubtenantSelector({ subTenants, subtenantID, history }) {
  const [showAlert, setShowAlert] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const [, setIsErrorsVisible] = useState(false);
  const [tenantChangeDailog, setTenantChangeDailog] = useState(false);
  const [actionValue, setActionValue] = useState({
    value: subtenantID,
    label: subtenantID,
  });
  const [isLoading, setIsLoading] = useState(false);
  const [, setFlag] = useState(false);
  const handleCancel = () => {
    setTenantChangeDailog(false);
    setActionValue({ value: subtenantID, label: subtenantID });
  };

  const handleSubtenantChangeSuccess = (newSubtenantId) => {
    setActionValue({ value: newSubtenantId, label: newSubtenantId });
    setTenantChangeDailog(false);
  };
  return (
    <>
      {subTenants?.length > 0 && subtenantID && (
        <ChangeSub
          setTenantChangeDailog={setTenantChangeDailog}
          setShowAlert={setShowAlert}
          setIsLoading={setIsLoading}
          setIsErrorsVisible={setIsErrorsVisible}
          setFlag={setFlag}
          setErrorMessage={setErrorMessage}
          setActionValue={setActionValue}
          subTenants={subTenants}
          actionValue={actionValue}
          handleCancel={handleCancel}
          handleSubtenantChangeSuccess={handleSubtenantChangeSuccess}
        />
      )}
      {isLoading && <Loader variant="primary" />}
      {tenantChangeDailog && (
        <SubTenantChange
          open={tenantChangeDailog}
          options={{
            heading: t("cm.change_client"),
            submitText: t("cm.ok"),
            cancelText: t("cm.cancel"),
            contentText: t("cm.you_are_Switching"),
          }}
          onCancel={handleCancel}
          history={history}
          subtenantActiveValue={subtenantID}
          action={actionValue}
          onSubtenantChangeSuccess={handleSubtenantChangeSuccess}
          setErrorMessage={setErrorMessage}
          setShowAlert={setShowAlert}
          setIsErrorsVisible={setIsErrorsVisible}
          setFlag={setFlag}
        />
      )}
      {showAlert && (
        <Alert alertType="danger" show={showAlert} dismiss={true} onClose={() => setShowAlert(false)}>
          {errorMessage}
        </Alert>
      )}
    </>
  );
}
